"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const utils_1 = require("~/utils/utils");
const consts_1 = require("~/store/consts");
const events_1 = require("~/consts/events");
const assets_1 = require("~/assets");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const types_1 = require("~/store/types");
const events_2 = require("~/utils/events");
const NewProjectModal_1 = __importDefault(require("~/components/ProjectManagement/NewProjectModal"));
const ErrorModal_1 = __importDefault(require("../ErrorModals/ErrorModal"));
const store_1 = require("~/store");
function EventsHandler({ refreshSceneHandler }) {
    const { t } = (0, react_i18next_1.useTranslation)('errors');
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const userId = (0, react_redux_1.useSelector)(selectors_1.selectUserId);
    const fastenersExistence = (0, react_redux_1.useSelector)(selectors_1.selectFastenersExistence);
    const { height } = (0, useWindowDimensions_1.default)();
    const widgetHeight = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetHeight)(consts_1.WIDGETS.RECOMMENDED_FASTENERS_WIDGET));
    const widgetWidth = (0, react_redux_1.useSelector)((0, selectors_1.selectWidgetWidth)(consts_1.WIDGETS.RECOMMENDED_FASTENERS_WIDGET));
    const { isOrderCompleted, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const { dispatchCloseProject, dispatchAddItemToBOM, dispatchRemoveItemsFromBOM, dispatchUpdateItemToBOM, dispatchAddServicesToBOM, dispatchUpdateServiceToBOM, dispatchRemoveServicesFromBOM, dispatchRecommendedFasteners, dispatchSetSelectedObjectsUUIDs, dispatchSetIsImperialMeasurementUsed, dispatchUpdateWidgetPosition, dispatchSendProjectScreenshot, dispatchSetProjectLoading, dispatchReplaceCurrentProjectItems, dispatchOpenAiWindow, dispatchSetBomNeedsRecalculation, } = (0, redux_1.bindActionCreators)({
        dispatchAddItemToBOM: actions_1.requestAddItemsToBOM,
        dispatchRemoveItemsFromBOM: actions_1.requestRemoveItemsFromBOM,
        dispatchUpdateItemToBOM: actions_1.requestUpdateItemsToBOM,
        dispatchAddServicesToBOM: actions_1.requestAddServicesToBOM,
        dispatchRemoveServicesFromBOM: actions_1.requestRemoveServicesFromBOM,
        dispatchUpdateServiceToBOM: actions_1.requestUpdateServicesToBOM,
        dispatchRecommendedFasteners: actions_1.requestRecommendedFasteners,
        dispatchSetSelectedObjectsUUIDs: actions_1.setSelectedObjectsUUIDs,
        dispatchSetIsImperialMeasurementUsed: actions_1.setIsImperialMeasurementUsed,
        dispatchUpdateWidgetPosition: actions_1.updateWidgetPosition,
        dispatchSendProjectScreenshot: actions_1.sendProjectScreenshot,
        dispatchCloseProject: actions_1.requestCloseProject,
        dispatchSetProjectLoading: actions_1.setProjectLoading,
        dispatchReplaceCurrentProjectItems: actions_1.replaceCurrentProjectItemsAction,
        dispatchOpenAiWindow: actions_1.openAiWindow,
        dispatchSetBomNeedsRecalculation: actions_1.setBomNeedsRecalculation,
    }, (0, react_redux_1.useDispatch)());
    const toBOMEvent = (element) => (Object.assign(Object.assign({}, element), { projectId,
        userId }));
    const maybeDeferBomForAi = (events) => {
        if (!events.some((ev) => ev.isAiAction)) {
            return;
        }
        dispatchSetBomNeedsRecalculation(true);
        // Don't open a new window mid-load
        const isMidLoad = (0, selectors_1.selectBOMLoading)(store_1.store.getState()) !== types_1.LOADING_STATE.LOADING;
        if (projectId !== undefined && isMidLoad) {
            dispatchOpenAiWindow({ projectId, userId });
        }
    };
    const updateItemsToBOMHandler = (e) => {
        if (!projectId) {
            return;
        }
        const events = e.detail.map(toBOMEvent);
        maybeDeferBomForAi(events);
        dispatchUpdateItemToBOM(events);
    };
    const addServicesToBOMHandler = (e) => {
        if (!projectId) {
            return;
        }
        const events = [];
        e.detail.forEach((element) => {
            events.push(Object.assign(Object.assign({}, element), { projectId, userId }));
        });
        dispatchAddServicesToBOM(events);
    };
    const updateServicesToBOMHandler = (e) => {
        if (!projectId) {
            return;
        }
        const events = [];
        e.detail.forEach((element) => {
            events.push(Object.assign(Object.assign({}, element), { projectId, userId }));
        });
        dispatchUpdateServiceToBOM(events);
    };
    const removeServicesFromBOMHandler = (e) => {
        if (!projectId) {
            return;
        }
        const events = [];
        e.detail.forEach((element) => {
            events.push(Object.assign(Object.assign({}, element), { projectId, userId }));
        });
        dispatchRemoveServicesFromBOM(events);
    };
    const addItemToBOMHandler = (e) => {
        const events = e.detail.map(toBOMEvent);
        maybeDeferBomForAi(events);
        if (!projectId && !userId) {
            dispatchSetProjectLoading();
        }
        dispatchAddItemToBOM(events);
        if (!projectId && userId) {
            dispatchCloseProject();
            (0, events_2.showModal)(react_1.default.createElement(NewProjectModal_1.default, null));
        }
    };
    const removeItemsFromBOMHandler = (e) => {
        if (!projectId) {
            return;
        }
        const events = e.detail.map(toBOMEvent);
        maybeDeferBomForAi(events);
        dispatchRemoveItemsFromBOM(events);
    };
    const selectFastenerEventHandler = (e) => {
        if (!isOrderCompleted) {
            dispatchRecommendedFasteners({
                projectId,
                uuid: e.detail.uuid,
            });
            dispatchUpdateWidgetPosition({
                widgetName: consts_1.WIDGETS.RECOMMENDED_FASTENERS_WIDGET,
                position: (0, utils_1.calculateWidgetPosition)(e.detail.x, e.detail.y, widgetHeight, widgetWidth, height),
            });
        }
    };
    const selectedObjectsChangedHandler = (e) => {
        dispatchSetSelectedObjectsUUIDs(e.detail);
    };
    const measurementUnitChangedHandler = (e) => {
        dispatchSetIsImperialMeasurementUsed(e.detail);
    };
    const takeIsometricScreenshotHandler = (e) => {
        dispatchSendProjectScreenshot(e.detail);
    };
    const replaceCurrentProjectItemsHandler = (e) => {
        dispatchReplaceCurrentProjectItems(e.detail);
    };
    let errorModalShown = false;
    const handleWSConnectionStatus = (e) => {
        const isConnectionError = e.detail.status === types_1.LOADING_STATE.WS_DISCONNECTED;
        if (isConnectionError && !errorModalShown) {
            errorModalShown = true;
            (0, events_2.showModal)(react_1.default.createElement(ErrorModal_1.default, { icon: assets_1.svgExclamationMark, header: t('error-connection.error-header'), messages: [t('error-connection.error-message')], imgClassName: "custom", errorBoundary: true }));
        }
        else if (errorModalShown) {
            errorModalShown = false;
            (0, events_2.hideModal)();
        }
    };
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_1.refreshScene, refreshSceneHandler);
        return () => {
            document.body.removeEventListener(events_1.addItemsToBOM, addItemToBOMHandler);
            document.body.removeEventListener(events_1.addServicesToBOM, addServicesToBOMHandler);
            document.body.removeEventListener(events_1.updateItemsToBOM, updateItemsToBOMHandler);
            document.body.removeEventListener(events_1.updateServicesToBOM, updateServicesToBOMHandler);
            document.body.removeEventListener(events_1.removeItemsFromBOM, removeItemsFromBOMHandler);
            document.body.removeEventListener(events_1.removeServicesFromBOM, removeServicesFromBOMHandler);
            document.body.removeEventListener(events_1.selectFastener, selectFastenerEventHandler);
            document.body.removeEventListener(events_1.selectedObjectsChanged, selectedObjectsChangedHandler);
            document.body.removeEventListener(events_1.measurementUnitChanged, measurementUnitChangedHandler);
            document.body.removeEventListener(events_1.refreshScene, refreshSceneHandler);
            if (!isProjectViewOnly) {
                document.body.removeEventListener(events_1.takeIsometricScreenshot, takeIsometricScreenshotHandler);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_1.addItemsToBOM, addItemToBOMHandler);
        document.body.addEventListener(events_1.measurementUnitChanged, measurementUnitChangedHandler);
        document.body.addEventListener(events_1.wsConnectionStatusChanged, handleWSConnectionStatus);
        document.body.addEventListener(events_1.replaceCurrentProjectItems, replaceCurrentProjectItemsHandler);
        if (projectId) {
            document.body.addEventListener(events_1.addItemsToBOM, addItemToBOMHandler);
            document.body.addEventListener(events_1.addServicesToBOM, addServicesToBOMHandler);
            document.body.addEventListener(events_1.updateItemsToBOM, updateItemsToBOMHandler);
            document.body.addEventListener(events_1.updateServicesToBOM, updateServicesToBOMHandler);
            document.body.addEventListener(events_1.removeItemsFromBOM, removeItemsFromBOMHandler);
            document.body.addEventListener(events_1.removeServicesFromBOM, removeServicesFromBOMHandler);
            document.body.addEventListener(events_1.selectFastener, selectFastenerEventHandler);
            document.body.addEventListener(events_1.selectedObjectsChanged, selectedObjectsChangedHandler);
            if (!isProjectViewOnly) {
                document.body.addEventListener(events_1.takeIsometricScreenshot, takeIsometricScreenshotHandler);
            }
        }
        return () => {
            document.body.removeEventListener(events_1.addItemsToBOM, addItemToBOMHandler);
            document.body.removeEventListener(events_1.addServicesToBOM, addServicesToBOMHandler);
            document.body.removeEventListener(events_1.updateItemsToBOM, updateItemsToBOMHandler);
            document.body.removeEventListener(events_1.updateServicesToBOM, updateServicesToBOMHandler);
            document.body.removeEventListener(events_1.removeServicesFromBOM, removeServicesFromBOMHandler);
            document.body.removeEventListener(events_1.measurementUnitChanged, measurementUnitChangedHandler);
            if (!isProjectViewOnly) {
                document.body.removeEventListener(events_1.takeIsometricScreenshot, takeIsometricScreenshotHandler);
            }
            document.body.removeEventListener(events_1.removeItemsFromBOM, removeItemsFromBOMHandler);
            document.body.removeEventListener(events_1.wsConnectionStatusChanged, handleWSConnectionStatus);
            document.body.removeEventListener(events_1.replaceCurrentProjectItems, replaceCurrentProjectItemsHandler);
        };
    }, [projectId, userId, isProjectViewOnly]);
    (0, react_1.useEffect)(() => {
        document.body.dispatchEvent((0, events_2.requestFastenersExistenceEvent)(fastenersExistence));
    }, [fastenersExistence]);
    return react_1.default.createElement("div", null);
}
exports.default = EventsHandler;
